import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { useRouter } from 'next/router'

export function useIsProfilePageLayout(): boolean {
  const router = useRouter()
  return router.pathname.includes(Routes.PAGE_EDITOR)
}
